export default "__VITE_ASSET__DuACmrDQ__"